import{toDate as t}from"./toDate.js";function r(r){return Math.trunc(+t(r)/1e3)}export{r as default,r as getUnixTime};
//# sourceMappingURL=getUnixTime.js.map
